import React, { useState } from "react";
import axios from "../../api/axios";
import "./AssignContractNumberModal.css";

export default function AssignContractNumberModal({
  isOpen,
  onClose,
  contract,
  token,
  locale = "kz",
  onSaved = () => {},
}) {
  // Хуки — всегда вызываем
  const t = {
    kz: {
      title: "Келісім шарт нөмірін тағайындау",
      number: "Келісім шарт нөмірі",
      date: "Күні",
      save: "Сақтау",
      cancel: "Болдырмау",
      success: "Нөмір сәтті тағайындалды!",
      error: "Қате орын алды",
      required: "Барлық өрістерді толтырыңыз",
    },
    ru: {
      title: "Назначить номер договора",
      number: "Номер договора",
      date: "Дата",
      save: "Сохранить",
      cancel: "Отмена",
      success: "Номер успешно назначен!",
      error: "Произошла ошибка",
      required: "Заполните все поля",
    },
  }[locale];

  const [form, setForm] = useState({
    contract_number: "",
    contract_date: new Date().toISOString().slice(0, 10),
  });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const disabled =
    !form.contract_number.trim() || !form.contract_date.trim();

  const submit = async () => {
    if (disabled) {
      setErr(t.required);
      return;
    }
    setErr("");
    setMsg("");
    try {
      setLoading(true);
      const url = `/contracts/${contract?.id}/assign-number`;
      await axios.post(
        url,
        {
          contract_number: form.contract_number,
          contract_date: form.contract_date,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMsg(t.success);
      setTimeout(() => {
        onSaved();
        onClose();
      }, 500);
    } catch (e) {
  
      setErr(t.error);
    } finally {
      setLoading(false);
    }
  };

  // Условный рендер после хуков
  if (!isOpen) return null;

  return (
    <div className="anm-overlay" onMouseDown={onClose}>
      <div className="anm-box" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="anm-title">{t.title}</h3>
        <div className="anm-body">
          <label>
            {t.number}
            <input
              type="text"
              value={form.contract_number}
              onChange={(e) =>
                setForm((s) => ({ ...s, contract_number: e.target.value }))
              }
              placeholder="Д-25/45"
            />
          </label>

          <label>
            {t.date}
            <input
              type="date"
              value={form.contract_date}
              onChange={(e) =>
                setForm((s) => ({ ...s, contract_date: e.target.value }))
              }
            />
          </label>

          {err && <div className="anm-error">{err}</div>}
          {msg && <div className="anm-success">{msg}</div>}
        </div>

        <div className="anm-actions">
          <button className="btn-primary" onClick={submit} disabled={loading || disabled}>
            {t.save}
          </button>
          <button className="btn-secondary" onClick={onClose} disabled={loading}>
            {t.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}
